import { render, staticRenderFns } from "./AppBarUserMenu.vue?vue&type=template&id=3a658544"
import script from "./AppBarUserMenu.vue?vue&type=script&lang=js"
export * from "./AppBarUserMenu.vue?vue&type=script&lang=js"
import style0 from "./AppBarUserMenu.vue?vue&type=style&index=0&id=3a658544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports